import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH4Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getBackgroundColorOptions,
  getBorderColorOptions,
} from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "statCard",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createH4Block({
          text: "94%",
        }),
        createPBlock({
          text: "Client satisfaction rate",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "var(--theme-website-color-background-primary)",
        }),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "1.25rem",
            paddingRight: "1.25rem",
            paddingLeft: "1.25rem",
            paddingBottom: "1.25rem",
          },
        }),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginRight: "0",
            marginLeft: "0",
            marginBottom: "0",
          },
        }),
        borderColor: getBorderColorOptions({
          defaultValue: "var(--theme-website-color-border-primary)",
        }),
        textAlign: getTextAlignOptions("center"),
      },
    },
  },
};
